import { RequestBuilder } from "../requestBuilder";
import {
  CreateLabelInputSchema,
  UpdateLabelInputSchema,
  LabelIdParamsSchema,
  LabelsSyncSchema,
  BulkAssociateLabelInputSchema,
  AssociateLabelResponseSchema,
  DisassociateLabelInputSchema,
  LabelAssociationsSyncSchema,
  BulkDisassociateLabelInputSchema,
} from "./labelClient.types";
import { LabelSchema } from "@storytell/types";

export const LabelsSyncRequestConfig = new RequestBuilder({
  path: () => "/labels-sync",
  responseSchema: LabelsSyncSchema,
});

export const CreateLabelRequestConfig = new RequestBuilder({
  path: () => "/labels",
  responseSchema: LabelSchema,
  bodySchema: CreateLabelInputSchema,
}).withMethod("POST");

export const DeleteLabelRequestConfig = new RequestBuilder({
  paramsSchema: LabelIdParamsSchema,
  path: (params) => `/labels/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined);

export const UpdateLabelRequestConfig = new RequestBuilder({
  paramsSchema: LabelIdParamsSchema,
  path: ({ id }) => `/labels/${id}`,
  responseSchema: LabelSchema,
  bodySchema: UpdateLabelInputSchema,
}).withMethod("POST");

export const AssociateLabelRequestConfig = new RequestBuilder({
  path: () => "/label-associations",
  responseSchema: AssociateLabelResponseSchema,
  bodySchema: BulkAssociateLabelInputSchema,
}).withMethod("POST");

export const DisassociateLabelRequestConfig = new RequestBuilder({
  path: () => "/label-associations/disassociate",
  bodySchema: BulkDisassociateLabelInputSchema,
}).withMethod("POST");

export const LabelAssociationsSyncRequestConfig = new RequestBuilder({
  path: () => "/label-associations",
  responseSchema: LabelAssociationsSyncSchema,
});
